import { AdminLoginForm } from '../AdminLogin';
import { UserLoginForm } from '../UserLogin';
import { OperatorLoginForm } from '../OperatorLogin';

/**
 * Login Form Component
 * Routes to admin, operator, or user login based on panel prop
 */
function LoginForm({ onLogin, panel = 'user' }) {
    // Admin login form
    if (panel === 'admin') {
        return <AdminLoginForm onLogin={onLogin} />;
    }

    // Operator login form
    if (panel === 'operator') {
        return <OperatorLoginForm onLogin={onLogin} />;
    }

    // User login form (default)
    return <UserLoginForm onLogin={onLogin} />;
}

export default LoginForm;
